import React, { useContext } from "react";

import { CSContext } from "../contexts/CSContext";


const CSIdentifierInput = (props: any) => {
    const { versionName, setVersionName } = useContext(CSContext)
    const disabled = ['edit', 'edit_version'].includes(props?.mode)
    return (
        <div className="tw-ml-5 tw-w-[25%]">
            <label className="tw-ml-5 tw-mb-2">Identifier Name</label>
            <span className="tw-text-red-500 tw-ml-2">*</span>

            <input
                className={`tw-flex ${disabled ? "tw-bg-gray-100" : ''} tw-w-[100%] tw-border tw-h-10 tw-rounded-md tw-ml-3 tw-px-2 tw-placeholder-gray-dark  tw-text-gray-800 `}
                onChange={(e) => {
                    setVersionName(e?.target?.value)
                }}
                value={versionName}
                placeholder={"Enter Identifier"}
                disabled={disabled}
            />
        </div>
    );
};

export default CSIdentifierInput;
